'use client';

import React, { useContext } from 'react';

// Actions that can be individually exempted from a block, so a partial block
// (e.g. a fraud-locked claim) can disable everything except these.
export const enablementActions = [
  'messaging',
  'documentation',
  'claim_responsible',
] as const;

export type EnablementAction = (typeof enablementActions)[number];

export interface EnablementContextProps {
  disabled?: boolean;
  reason?: string;
  exemptActions?: ReadonlyArray<EnablementAction>;
}

const EnablementContext = React.createContext<
  EnablementContextProps | undefined
>(undefined);

export const useEnablement = () => useContext(EnablementContext)!;

export const useSafeEnablement = () => useContext(EnablementContext);

export const EnablementProvider = ({
  children,
  ...props
}: EnablementContextProps & {
  children: React.ReactNode;
}) => {
  return (
    <EnablementContext.Provider value={props}>
      {children}
    </EnablementContext.Provider>
  );
};
